// Dedicated RSM keys for the soft-skills training listing calls, kept distinct
// from the hard-skills ones so their request/response state stays independent.
export const KEY_GET_DASHBOARD_CONTENTS = 'get.soft-dashboard-contents.call';
export const KEY_GET_CONTENTS_BY_TYPE = 'get.soft-contents-by-type.call';
export const KEY_GET_MY_CONTENTS = 'get.soft-my-contents.call';
export const KEY_GET_TAGS = 'get.soft-tags-contents.call';
export const KEY_GET_CONTENTS_IN_PROGRESS = 'get.soft-contents-in-progress.call';
